function createAction(name) {
  return `@@portal/${name}`;
}
export const SET_PORTAL = createAction('SET_PORTAL');
export function setPortal(portal) {
  return {
    type: SET_PORTAL,
    portal
  };
}